import { Link, useLocation } from "react-router-dom";
import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaPhoneAlt,
    FaFax,
    FaEnvelope,
    FaMapMarkerAlt,
    FaBuilding,
} from "react-icons/fa";
import React from "react";

export default function Footer({ onLoginClick }) {
    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
        <footer className="bg-primary text-white px-6 py-12">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-10">
                {/* Legal */}
                <div>
                    <details className="group md:open" open>
                        <summary className="font-semibold text-lg mb-3 cursor-pointer flex justify-between items-center md:cursor-default md:mb-4">
                            Legal
                            <span className="md:hidden transition-transform group-open:rotate-180">⌄</span>
                        </summary>
                        <ul className="space-y-2 text-sm pl-1 md:pl-0">
                            <li><Link to="/terms" className="hover:underline transition">Terms & Conditions</Link></li>
                            <li><Link to="/privacy" className="hover:underline transition">Privacy Policy</Link></li>
                        </ul>
                    </details>
                </div>

                {/* Navigation */}
                <div>
                    <details className="group md:open" open>
                        <summary className="font-semibold text-lg mb-3 cursor-pointer flex justify-between items-center md:cursor-default md:mb-4">
                            Navigation
                            <span className="md:hidden transition-transform group-open:rotate-180">⌄</span>
                        </summary>
                        <ul className="space-y-2 text-sm pl-1 md:pl-0">
                            {!isHome && <li><Link to="/" className="hover:underline transition">Home</Link></li>}
                            <li><Link to="/accommodation" className="hover:underline transition">Accommodation</Link></li>
                            <li><Link to="/properties" className="hover:underline transition">Properties</Link></li>
                            <li><Link to="/dining" className="hover:underline transition">Dining</Link></li>
                            <li><Link to="/contact" className="hover:underline transition">Contact</Link></li>
                            <button
                                onClick={onLoginClick}
                                className="text-sm text-white hover:text-[#FEB339] transition"
                            >
                                Login
                            </button>
                            <li><Link to="/careers" className="hover:underline transition">Career Opportunities</Link></li>
                        </ul>
                    </details>
                </div>

                {/* Contact */}
                <div>
                    <details className="group md:open" open>
                        <summary className="font-semibold text-lg mb-3 cursor-pointer flex justify-between items-center md:cursor-default md:mb-4">
                            Contact
                            <span className="md:hidden transition-transform group-open:rotate-180">⌄</span>
                        </summary>
                        <ul className="space-y-2 text-sm pl-1 md:pl-0">
                            <li className="flex items-start gap-3">
                                <FaPhoneAlt className="text-[#F29E38] text-base pt-[2px]" />
                                <a href="tel:+27169404444" className="hover:underline transition">
                                    +27 (0) 16 940 4444
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <FaFax className="text-[#F29E38] text-base pt-[2px]" />
                                <a href="fax:+27112529219" className="hover:underline transition">
                                    +27 (0) 11 252 9219
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <FaEnvelope className="text-[#F29E38] text-base pt-[2px]" />
                                <a href="mailto:mrd@wol.co.za" className="hover:underline transition">
                                    mrd@wol.co.za
                                </a>
                            </li>
                        </ul>
                    </details>
                </div>

                {/* Address */}
                <div>
                    <details className="group md:open" open>
                        <summary className="font-semibold text-lg mb-3 cursor-pointer flex justify-between items-center md:cursor-default md:mb-4">
                            Address
                            <span className="md:hidden transition-transform group-open:rotate-180">⌄</span>
                        </summary>
                        <ul className="space-y-2 text-sm pl-1 md:pl-0">
                            <li className="flex items-start gap-3">
                                <FaBuilding className="text-[#F29E38] text-base pt-[2px]" />
                                <span>
                                    Office Suite 1,<br />
                                    Pasteur Court,<br />
                                    201 Pasteur Blvd,<br />
                                    Vanderbijlpark
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <FaEnvelope className="text-[#F29E38] text-base pt-[2px]" />
                                <span>
                                    P.O. Box 6269<br />
                                    Vanderbijlpark, 1900<br />
                                    South Africa
                                </span>
                            </li>
                            <li className="flex items-center gap-3">
                                <FaMapMarkerAlt className="text-[#F29E38] text-base" />
                                <a
                                    href="https://maps.app.goo.gl/f1qpCSnNbCf8zJT5A"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline transition"
                                >
                                    View on Google Maps
                                </a>
                            </li>
                        </ul>
                    </details>
                </div>

                {/* Social */}
                <div>
                    <details className="group md:open" open>
                        <summary className="font-semibold text-lg mb-3 cursor-pointer flex justify-between items-center md:cursor-default md:mb-4">
                            Follow Us
                            <span className="md:hidden transition-transform group-open:rotate-180">⌄</span>
                        </summary>
                        <div className="flex space-x-4 pl-1 md:pl-0">
                            <a
                                href="https://www.facebook.com/BeneckeGroup"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                className="text-white hover:text-[#F29E38] text-xl transition"
                            >
                                <FaFacebookF />
                            </a>
                            <a
                                href="https://www.instagram.com/thebeneckegroup/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                                className="text-white hover:text-[#F29E38] text-xl transition"
                            >
                                <FaInstagram />
                            </a>
                            <a
                                href="https://www.linkedin.com/in/johan-benecke-1822724a"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                                className="text-white hover:text-[#F29E38] text-xl transition"
                            >
                                <FaLinkedinIn />
                            </a>
                        </div>
                    </details>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="border-t border-white/20 mt-10 pt-6 flex flex-col items-center justify-center text-xs text-white/80 gap-2 text-center">
                <p>© {new Date().getFullYear()} Benecke Group. All rights reserved.</p>

                {/* Lumo Lime Signature Line */}
                <a
                    href="https://lumolime.tech"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-xs text-white hover:text-[#63c100] transition duration-300"
                >
                    <img
                        src="/images/lumo-lime-icon.png"
                        alt="Lumo Lime Icon"
                        className="w-4 h-4 mr-2"
                    />
                    <span className="relative group">
                        <span className="block group-hover:hidden">
                            This site was designed by Lumo Lime Consulting
                        </span>
                        <span className="hidden group-hover:block text-[#63c100] font-semibold">
                            lime it
                        </span>
                    </span>
                </a>
            </div>
        </footer>
    );
}
